import * as React from 'react';

import AccessibleSVG from '../accessible-svg';

import { Icon } from '../iconTypes';

const IconCommentsBadge = ({ className = '', color = '#777', height = 15, title, width = 14 }: Icon) => (
    <AccessibleSVG
        className={`icon-comments-badge ${className}`}
        height={height}
        title={title}
        viewBox="0 0 14 15"
        width={width}
    >
        <g className="stroke-color" fill="none" fillRule="evenodd" stroke={color} strokeWidth=".875">
            <path d="M3.063 13.938l2.88-2.905h5.432c1.208 0 2.188-.98 2.188-2.187v-6.22c0-1.21-.98-2.188-2.188-2.188h-8.75c-1.208 0-2.188.98-2.188 2.187v6.22c0 1.21.98 2.188 2.188 2.188h.438v2.905z" />
            <path d="M3.938 3.97h6.124M3.938 7.5h6.124" strokeLinecap="round" strokeLinejoin="round" />
        </g>
    </AccessibleSVG>
);

export default IconCommentsBadge;
